// import React, { useEffect, useRef, useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { FaShoppingBag } from "react-icons/fa";
// import { toast } from "react-toastify";
// import axios from "axios";
// import NotificationDropdown from "./Notification";

// const Navbar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [showMenu, setShowMenu] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userName, setUserName] = useState("");
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
//   const dropdownRef = useRef(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchLoading, setSearchLoading] = useState(false);
//   const [cartCount, setCartCount] = useState(0);
//   const [wishcount, setWishCount] = useState(0);
//   const [showNotifications, setShowNotifications] = useState(false);
//   const [menuItems, setMenuItems] = useState([]);

//   const notificationRef = useRef(null);





//   // Check login status
//   const checkLoginStatus = () => {
//     const user = localStorage.getItem("user");
//     console.log("Checking login status, user data:", user); // Debug log
    
//     if (user) {
//       try {
//         const userData = JSON.parse(user);
//         console.log("Parsed user data:", userData); // Debug log
//         setIsLoggedIn(true);
//         // Try multiple possible fields for user name
//         setUserName(userData.name || userData.username || userData.email || userData.mobile || "User");
//       } catch (error) {
//         console.error("Error parsing user data:", error);
//         localStorage.removeItem("user");
//         setIsLoggedIn(false);
//       }
//     } else {
//       setIsLoggedIn(false);
//     }
//   };

//   // Check on mount and when location changes
//   useEffect(() => {
//     checkLoginStatus();
//   }, [location]);

//   // Listen for custom login event
//   useEffect(() => {
//     const handleLoginEvent = () => {
//       console.log("Login event received"); // Debug log
//       checkLoginStatus();
//     };

//     window.addEventListener("userLoggedIn", handleLoginEvent);
//     return () => window.removeEventListener("userLoggedIn", handleLoginEvent);
//   }, []);

//   const toggleDropdown = (index) => {
//     setOpenDropdownIndex(openDropdownIndex === index ? null : index);
//   };

//   const handleAccordionToggle = (index) => {
//     if (window.innerWidth <= 768) {
//       setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
//     }
//   };

//  const handleLogout = () => {
//   console.log("Logging out...");

//   // ✅ Clear ALL auth-related data
//   localStorage.removeItem("user");
//   localStorage.removeItem("user_id"); // 🔥 THIS WAS MISSING
//   localStorage.removeItem("cart");
//   localStorage.removeItem("wishlist");
//   localStorage.removeItem("address");
//   localStorage.removeItem("orders");

//   sessionStorage.clear();

//   // 🔥 Notify whole app
//   window.dispatchEvent(new Event("userLoggedOut"));

//   // Reset UI state
//   setIsLoggedIn(false);
//   setUserName("");
//   setShowDropdown(false);

//   toast.success("Logged out successfully!");
//   navigate("/");
// };



//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleSearch = async () => {
//   if (!searchQuery.trim()) return;

//   try {
//     setSearchLoading(true);

//     const res = await axios.get(
//       "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
//     );

//     if (res.data.status === true && res.data.data) {

//       // ✅ FILTER FIRST
//       const matchedProducts = res.data.data.filter((item) =>
//         `${item.product_name} ${item.company_name} ${item.model_name}`
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );

//       // ✅ TRANSFORM (VERY IMPORTANT)
//       const transformedProducts = matchedProducts.map((product) => ({
//         id: product.product_id,
//         brand: product.company_name || product.assign_vendor,
//         name: product.product_name,
//         price: parseFloat(product.current_price),
//         oldPrice: parseFloat(product.old_price),
//         discount: Math.round(
//           ((parseFloat(product.old_price) - parseFloat(product.current_price)) /
//             parseFloat(product.old_price)) *
//             100
//         ),
//         category: product.subcategory_id,
//         color: product.available_colors,
//         images:
//           product.multi_image?.length > 0
//             ? product.multi_image.map(
//                 (img) =>
//                   `https://cyberathon.com/multivendor/${img}`
//               )
//             : ["img/placeholder.jpg"],
//         rating: parseFloat(product.rating) || 0,
//         viewers: `${parseFloat(product.rating || 0).toFixed(1)}K`,
//         stock: product.status || "In Stock",
//         description: product.description,
//         productDetails: product.product_details,
//       }));

//       // ✅ NAVIGATE TO PRODUCTS PAGE
//       navigate("/products", {
//         state: {
//           query: searchQuery,
//           results: transformedProducts,
//         },
//       });
//     }
//   } catch (error) {
//     console.error("Search Error:", error);
//     toast.error("Search failed");
//   } finally {
//     setSearchLoading(false);
//   }
// };

// useEffect(() => {
//   fetchwishCount();
// }, [location, isLoggedIn]);



// const fetchwishCount = async () => {
//   const user_id = localStorage.getItem("user_id");

//   // 🧑‍🦱 GUEST USER
//   if (!user_id) {
//     const guestwish =
//       JSON.parse(localStorage.getItem("guest_wishlist")) ||
//       JSON.parse(localStorage.getItem("wishlist")) ||
//       [];
//     setWishCount(guestwish.length);
//     return;
//   }

//   // 👤 LOGGED-IN USER
//   try {
//     const formData = new FormData();
//     formData.append("user_id", user_id);

//     const res = await axios.post(
//       "https://cyberathon.com/multivendor/index.php/Api/Master_controller/wish_list",
//       formData,
//       { headers: { "Content-Type": "multipart/form-data" } }
//     );
//     console.log("Wishlist count response:", res.data); 

//     if (res.data.status === true || res.data.status === "true") {
//       // 🔥 FIX: Set the LENGTH of the wishlist array, not the array itself
//       const wishlistArray = res.data.wishlist || [];
//       setWishCount(Array.isArray(wishlistArray) ? wishlistArray.length : 0);
//     } else {
//       setWishCount(0);
//     }
//   } catch (error) {
//     console.error("Wishlist count error:", error);
//     setWishCount(0);
//   }
// };

// useEffect(() => {
//   const handlewishUpdate = () => fetchwishCount();

//   window.addEventListener("wishUpdated", handlewishUpdate);
//   window.addEventListener("userLoggedOut", handlewishUpdate);

//   return () => {
//     window.removeEventListener("wishUpdated", handlewishUpdate);
//     window.removeEventListener("userLoggedOut", handlewishUpdate);
//   };
// }, []);

// useEffect(() => {
//   fetchCartCount();
// }, [location, isLoggedIn]);

// useEffect(() => {
//   const handleClickOutside = (e) => {
//     if (
//       notificationRef.current &&
//       !notificationRef.current.contains(e.target)
//     ) {
//       setShowNotifications(false);
//     }
//   };

//   document.addEventListener("mousedown", handleClickOutside);
//   return () =>
//     document.removeEventListener("mousedown", handleClickOutside);
// }, []);




// const fetchCartCount = async () => {
//   const user_id = localStorage.getItem("user_id");

//   // 🧑‍🦱 GUEST USER
//   if (!user_id) {
//     const guestCart =
//       JSON.parse(localStorage.getItem("guest_cart")) ||
//       JSON.parse(localStorage.getItem("cart")) ||
//       [];
//     setCartCount(guestCart.length);
//     return;
//   }

//   // 👤 LOGGED-IN USER
//   try {
//     const res = await axios.post(
//       "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_cart",
//       { user_id }
//     );

//     if (res.data.status === true && Array.isArray(res.data.data)) {
//       setCartCount(res.data.data.length);
//     } else {
//       setCartCount(0);
//     }
//   } catch (error) {
//     console.error("Cart count error:", error);
//     setCartCount(0);
//   }
// };

// useEffect(() => {
//   const handleCartUpdate = () => fetchCartCount();

//   window.addEventListener("cartUpdated", handleCartUpdate);
//   window.addEventListener("userLoggedOut", handleCartUpdate);

//   return () => {
//     window.removeEventListener("cartUpdated", handleCartUpdate);
//     window.removeEventListener("userLoggedOut", handleCartUpdate);
//   };
// }, []);


// const CATEGORY_MAP = {
//   1: "Electronics",
//   2: "Fashion",
//   3: "Home",
//   4: "Beauty",
// };


//   useEffect(() => {
//   fetchSubCategories();
// }, []);

// const fetchSubCategories = async () => {
//   try {
//     const res = await axios.get(
//       "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
//     );

//     if (res.data.status === "true") {
//       const rows = res.data.row;

//       // Group by category_id
//       const grouped = rows.reduce((acc, item) => {
//         const catName = CATEGORY_MAP[item.category_id] || "Other";

//         if (!acc[catName]) {
//           acc[catName] = [];
//         }

//         acc[catName].push({
//           id: item.subcategory_id,
//           name: item.subcategory_name,
//           image: item.image,
//           path: `/products?subcategory=${item.subcategory_id}`,
//         });

//         return acc;
//       }, {});

//       // Convert to menu format
//       const finalMenu = Object.keys(grouped).map((key) => ({
//         label: key,
//         items: grouped[key],
//       }));

//       setMenuItems(finalMenu);
//     }
//   } catch (error) {
//     console.error("Subcategory fetch error:", error);
//   }
// };


//   return (
//     <div>
//       <div className="header sticky">
//         <div className="nav-logo">
//           <Link to="/">
//             <img src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png" alt="logo" />
//           </Link>
//         </div>

//         {/* MOBILE MENU ICON */}
// <div
//   className="d-block d-lg-none"
//   onClick={() => setIsMobileMenuOpen((prev) => !prev)}
// >
//   <div className="mobile-menu-icon">
//     <i className={`fas ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`}></i>
//   </div>
// </div>

// {/* MOBILE MENU ITEMS */}
// {isMobileMenuOpen && (
//   <div className="mobile-menu m-1">
//     <ul className="mobile-menu-list">
//       {menuItems.map((menu, index) => (
//         <li key={index} className="mobile-menu-item">
//           {/* Menu Label */}
//           <div
//             className="menu-label d-flex justify-content-between align-items-center"
//             onClick={(e) => {
//               e.stopPropagation(); // 🧩 Prevent conflict with parent click
//               setOpenDropdownIndex((prev) => (prev === index ? null : index));
//             }}
//             style={{
//               cursor: "pointer",
//               fontWeight: "600",
//               padding: "10px 0",
//               borderBottom: "1px solid #e0e0e0",
//             }}
//           >
//             {menu.label}
//             <span className="mobile-arrow">
//               {openDropdownIndex === index ? "▲" : "▼"}
//             </span>
//           </div>

//           {/* Dropdown Items */}
//           {openDropdownIndex === index && (
//             <ul
//               className="submenu"
//               style={{
//                 listStyle: "none",
//                 paddingLeft: "15px",
//                 marginTop: "8px",
//                 marginBottom: "10px",
//                 backgroundColor: "#f9f9f9",
//                 borderRadius: "5px",
//                 overflow: "hidden",
//               }}
//             >
//               {menu.items.map((item, subIndex) => (
//                 <li
//                   key={subIndex}
//                   style={{
//                     padding: "8px 0",
//                     borderBottom: "1px solid #ddd",
//                   }}
//                 >
//                   <Link
//                     to={item.path}
//                     onClick={() => {
//                       setIsMobileMenuOpen(false);
//                       setOpenDropdownIndex(null);
//                     }}
//                     style={{
//                       color: "#333",
//                       textDecoration: "none",
//                       display: "block",
//                     }}
//                   >
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </li>
//       ))}
//     </ul>
//   </div>
// )}




//         <div className={`categories ${showMenu ? "show" : ""}`}>
//           <ul className="categories-ul">
//             {menuItems.map((menu, index) => (
//               <li
//                 key={index}
//                 className={`dropdown-content${index + 1} ${
//                   activeDropdown === index ? "active" : ""
//                 }`}
//               >
//                 <a
//                   href="#"
//                   onClick={(e) => {
//                     if (window.innerWidth <= 768) {
//                       e.preventDefault();
//                       handleAccordionToggle(index);
//                     }
//                   }}
//                 >
//                   {menu.label}
//                   <span className="mobile-arrow">
//                     {activeDropdown === index ? "▲" : "▼"}
//                   </span>
//                 </a>
//                 {menu.items.length > 0 && (
//                   <div className={`dropdown-menu dropdown-menu${index + 1}`}>
//                     <ul>
//                       {menu.items.map((item, i) => (
//                         <li key={i}>
//                           <Link to={item.path}>{item.name}</Link>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}
//               </li>
//             ))}
//           </ul>
//         </div>

//         <div
//           className="d-flex justify-content-center align-items-center p-3 nav-search"
//         >
//           <div
//             className="d-flex align-items-center rounded overflow-hidden"
//             style={{ width: "100%", backgroundColor: "#fff", border:"1px solid" }}
//           >
//             <div className="dropdown border-end" style={{ backgroundColor: "#f3f3f3" }}>
//               <button
//                 className="btn dropdown-toggle text-muted"
//                 type="button"
//                 data-bs-toggle="dropdown"
//                 aria-expanded="false"
//                 style={{
//                   height: "38px",
//                   borderRadius: "0",
//                   backgroundColor: "#f3f3f3",
//                   border: "none",
//                   fontSize: "14px",
//                   padding: "0 10px",
//                 }}
//               >
//                 All
//               </button>
//               <ul className="dropdown-menu">
//                 <li>
//                   <a className="dropdown-item" href="#">
//                     All Categories
//                   </a>
//                 </li>
//                 <li>
//                   <a className="dropdown-item" href="#">
//                     Electronics
//                   </a>
//                 </li>
//                 <li>
//                   <a className="dropdown-item" href="#">
//                     Fashion
//                   </a>
//                 </li>
//               </ul>
//             </div>

//             <input
//               type="text"
//               className="form-control border-0"
//               placeholder="Search"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && handleSearch()}
//               style={{
//                 boxShadow: "none",
//                 height: "38px",
//                 fontSize: "14px",
//               }}
//             />


//             <button
//   className="btn d-flex align-items-center justify-content-center"
//   onClick={handleSearch}
//   disabled={searchLoading}
//   style={{
//     backgroundColor: "black",
//     borderRadius: "0",
//     width: "45px",
//     height: "38px",
//   }}
// >
//   <i className="bi bi-search fs-5 text-white"></i>
// </button>

//           </div>
//         </div>

//         <div className="nav-last">
//           <div
//             className="profile-last-section"
//             onMouseEnter={() => setShowDropdown(true)}
//           >
//             <div
//               className="profile-icon"
//               onClick={() => setShowDropdown(!showDropdown)}
//             >
//               <img
//                 id="svg"
//                 src="https://www.svgrepo.com/show/198180/user-profile.svg"
//                 alt="profile"
//               />
//               <div>Profile</div>
//             </div>

//             {showDropdown && (
//               <div className="profile-dropdown" ref={dropdownRef}>
//                 {!isLoggedIn ? (
//                   <>
//                     <div className="welcome">
//                       <p>Welcome</p>
//                       <span>To access account and manage orders</span>
//                       <Link to="/login" onClick={() => setShowDropdown(false)}>
//                         <button>LOGIN / SIGNUP</button>
//                       </Link>
//                     </div>
//                     <hr />
//                   </>
//                 ) : (
//                   <>
//                     <div className="welcome">
//                       <p>Hello, {userName}!</p>
//                       <button 
//                         onClick={handleLogout} 
//                         style={{ 
//                           marginTop: "10px",
//                           cursor: "pointer",
//                         }}
//                       >
//                         LOGOUT
//                       </button>
//                     </div>
//                     <hr className="mt-0"/>
//                   </>
//                 )}
//                 <ul>
//                   <Link to="/Profilepage" onClick={() => setShowDropdown(false)}>
//                     <li>Profile</li>
//                   </Link>
//                   <Link to="/order" onClick={() => setShowDropdown(false)}>
//                     <li>Orders</li>
//                   </Link>
//                   <Link to="/Referfrnd" onClick={() => setShowDropdown(false)}>
//                     <li>Refer a friend</li>
//                   </Link>
//                   <li>Gift Cards</li>
//                   <Link to="/ContactUs" onClick={() => setShowDropdown(false)}>
//                     <li>Contact Us</li>
//                   </Link>
//                   <Link to="/Coupan" onClick={() => setShowDropdown(false)}>
//                     <li>Coupons</li>
//                   </Link>
//                 </ul>
//               </div>
//             )}
//           </div>

//           <div className="profile-last-section position-relative">
//   <Link to="/wishlist" className="text-decoration-none text-dark position-relative">
//               <img
//                 id="svg"
//                 src="https://www.svgrepo.com/show/14970/heart.svg"
//                 alt=""
//               />
//               {wishcount > 0 && (
//       <span
//         style={{
//           position: "absolute",
//           top: "-5px",
//           right: "-2px",
//           background: "red",
//           color: "white",
//           borderRadius: "50%",
//           padding: "2px 6px",
//           fontSize: "11px",
//           fontWeight: "bold",
//           minWidth: "18px",
//           textAlign: "center",
//         }}
//       >
//         {wishcount}
//       </span>
//               )}
//               <div>Wishlist</div>
//             </Link>
//           </div>

//           <div className="profile-last-section position-relative">
//   <Link to="/bag" className="text-decoration-none text-dark position-relative">
//     <FaShoppingBag size={19} />

//     {cartCount > 0 && (
//       <span
//         style={{
//           position: "absolute",
//           top: "-6px",
//           right: "-8px",
//           background: "red",
//           color: "white",
//           borderRadius: "50%",
//           padding: "2px 6px",
//           fontSize: "11px",
//           fontWeight: "bold",
//           minWidth: "18px",
//           textAlign: "center",
//         }}
//       >
//         {cartCount}
//       </span>
//     )}

//     <div>Bag</div>
//   </Link>
// </div>

// <div
//   className="profile-last-section position-relative"
//   ref={notificationRef}
// >
//   <div
//     className="text-dark text-center"
//     style={{ cursor: "pointer" }}
//     onClick={() => setShowNotifications((prev) => !prev)}
//   >
//     <i className="fa-regular fa-bell" style={{ fontSize: "18px" }}></i>
//     <div>Notifications</div>
//   </div>

//   {showNotifications && <NotificationDropdown />}
// </div>


//         </div>
//       </div>
//       <div></div>
//     </div>
//   );
// };

// export default Navbar;

// import React, { useEffect, useRef, useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { FaShoppingBag } from "react-icons/fa";
// import { toast } from "react-toastify";
// import axios from "axios";
// import NotificationDropdown from "./Notification";
// import './Navbar.css';

// const Navbar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [showMenu, setShowMenu] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userName, setUserName] = useState("");
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
//   const dropdownRef = useRef(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchLoading, setSearchLoading] = useState(false);
//   const [cartCount, setCartCount] = useState(0);
//   const [wishcount, setWishCount] = useState(0);
//   const [showNotifications, setShowNotifications] = useState(false);
//   const [menuItems, setMenuItems] = useState([]);
//   const [sellerMap, setSellerMap] = useState({});

//   const notificationRef = useRef(null);


  

//   // 🆕 Fetch seller list and create ID-to-name mapping
//   useEffect(() => {
//     const fetchSellers = async () => {
//       try {
//         const res = await axios.get(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_seller_registration"
//         );

//         if (res.data.status === "true" && Array.isArray(res.data.data)) {
//           const mapping = {};
//           res.data.data.forEach((seller) => {
//             mapping[seller.seller_id] = seller.business_name;
//           });
//           setSellerMap(mapping);
//           console.log("Seller mapping created:", mapping);
//         }
//       } catch (error) {
//         console.error("Seller fetch error:", error);
//       }
//     };

//     fetchSellers();
//   }, []);

//   // Check login status
//   const checkLoginStatus = () => {
//     const user = localStorage.getItem("user");
//     console.log("Checking login status, user data:", user); // Debug log
    
//     if (user) {
//       try {
//         const userData = JSON.parse(user);
//         console.log("Parsed user data:", userData); // Debug log
//         setIsLoggedIn(true);
//         // Try multiple possible fields for user name
//         setUserName(userData.name || userData.username || userData.email || userData.mobile || "User");
//       } catch (error) {
//         console.error("Error parsing user data:", error);
//         localStorage.removeItem("user");
//         setIsLoggedIn(false);
//       }
//     } else {
//       setIsLoggedIn(false);
//     }
//   };

//   // Check on mount and when location changes
//   useEffect(() => {
//     checkLoginStatus();
//   }, [location]);

//   // Listen for custom login event
//   useEffect(() => {
//     const handleLoginEvent = () => {
//       console.log("Login event received"); // Debug log
//       checkLoginStatus();
//     };

//     window.addEventListener("userLoggedIn", handleLoginEvent);
//     return () => window.removeEventListener("userLoggedIn", handleLoginEvent);
//   }, []);

//   const toggleDropdown = (index) => {
//     setOpenDropdownIndex(openDropdownIndex === index ? null : index);
//   };

//   const handleAccordionToggle = (index) => {
//     if (window.innerWidth <= 768) {
//       setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
//     }
//   };

//  const handleLogout = () => {
//   console.log("Logging out...");

//   // ✅ Clear ALL auth-related data
//   localStorage.removeItem("user");
//   localStorage.removeItem("user_id"); // 🔥 THIS WAS MISSING
//   localStorage.removeItem("cart");
//   localStorage.removeItem("wishlist");
//   localStorage.removeItem("address");
//   localStorage.removeItem("orders");

//   sessionStorage.clear();

//   // 🔥 Notify whole app
//   window.dispatchEvent(new Event("userLoggedOut"));

//   // Reset UI state
//   setIsLoggedIn(false);
//   setUserName("");
//   setShowDropdown(false);

//   toast.success("Logged out successfully!");
//   navigate("/");
// };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleSearch = async () => {
//     if (!searchQuery.trim()) return;

//     try {
//       setSearchLoading(true);

//       const res = await axios.get(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
//       );

//       if (res.data.status === true && res.data.data) {
//         const query = searchQuery.toLowerCase();

//         // ✅ ENHANCED FILTER: Include seller business name in search
//         const matchedProducts = res.data.data.filter((item) => {
//           const sellerName = sellerMap[item.seller_id] || "";
          
//           return (
//             `${item.product_name} ${item.company_name} ${item.model_name} ${sellerName}`
//               .toLowerCase()
//               .includes(query)
//           );
//         });

//         // ✅ TRANSFORM (VERY IMPORTANT)
//         const transformedProducts = matchedProducts.map((product) => ({
//           id: product.product_id,
//           brand: product.company_name || product.assign_vendor,
//           name: product.product_name,
//           price: parseFloat(product.current_price),
//           oldPrice: parseFloat(product.old_price),
//           discount: Math.round(
//             ((parseFloat(product.old_price) - parseFloat(product.current_price)) /
//               parseFloat(product.old_price)) *
//               100
//           ),
//           category: product.subcategory_id,
//           category_id: Number(product.category_id),
//           subcategory_id: Number(product.subcategory_id),
//           color: product.available_colors,
//           images:
//             product.multi_image?.length > 0
//               ? product.multi_image.map(
//                   (img) =>
//                     `https://cyberathon.com/multivendor/${img}`
//                 )
//               : ["img/placeholder.jpg"],
//           rating: parseFloat(product.rating) || 0,
//           viewers: `${parseFloat(product.rating || 0).toFixed(1)}K`,
//           stock: product.status || "In Stock",
//           description: product.description,
//           productDetails: product.product_details,
//           sellerName: sellerMap[product.seller_id] || "Unknown Seller",
//         }));

//         console.log(`Found ${transformedProducts.length} products matching "${searchQuery}"`);

//         // ✅ NAVIGATE TO PRODUCTS PAGE
//         navigate("/products", {
//           state: {
//             query: searchQuery,
//             results: transformedProducts,
//           },
//         });
//       }
//     } catch (error) {
//       console.error("Search Error:", error);
//       toast.error("Search failed");
//     } finally {
//       setSearchLoading(false);
//     }
//   };

// useEffect(() => {
//   fetchwishCount();
// }, [location, isLoggedIn]);

// const fetchwishCount = async () => {
//   const user_id = localStorage.getItem("user_id");

//   // 🧑‍🦱 GUEST USER
//   if (!user_id) {
//     const guestwish =
//       JSON.parse(localStorage.getItem("guest_wishlist")) ||
//       JSON.parse(localStorage.getItem("wishlist")) ||
//       [];
//     setWishCount(guestwish.length);
//     return;
//   }

//   // 👤 LOGGED-IN USER
//   try {
//     const formData = new FormData();
//     formData.append("user_id", user_id);

//     const res = await axios.post(
//       "https://cyberathon.com/multivendor/index.php/Api/Master_controller/wish_list",
//       formData,
//       { headers: { "Content-Type": "multipart/form-data" } }
//     );
//     console.log("Wishlist count response:", res.data); 

//     if (res.data.status === true || res.data.status === "true") {
//       // 🔥 FIX: Set the LENGTH of the wishlist array, not the array itself
//       const wishlistArray = res.data.wishlist || [];
//       setWishCount(Array.isArray(wishlistArray) ? wishlistArray.length : 0);
//     } else {
//       setWishCount(0);
//     }
//   } catch (error) {
//     console.error("Wishlist count error:", error);
//     setWishCount(0);
//   }
// };

// useEffect(() => {
//   const handlewishUpdate = () => fetchwishCount();

//   window.addEventListener("wishUpdated", handlewishUpdate);
//   window.addEventListener("userLoggedOut", handlewishUpdate);

//   return () => {
//     window.removeEventListener("wishUpdated", handlewishUpdate);
//     window.removeEventListener("userLoggedOut", handlewishUpdate);
//   };
// }, []);

// useEffect(() => {
//   fetchCartCount();
// }, [location, isLoggedIn]);

// useEffect(() => {
//   const handleClickOutside = (e) => {
//     if (
//       notificationRef.current &&
//       !notificationRef.current.contains(e.target)
//     ) {
//       setShowNotifications(false);
//     }
//   };

//   document.addEventListener("mousedown", handleClickOutside);
//   return () =>
//     document.removeEventListener("mousedown", handleClickOutside);
// }, []);

// const fetchCartCount = async () => {
//   const user_id = localStorage.getItem("user_id");

//   // 🧑‍🦱 GUEST USER
//   if (!user_id) {
//     const guestCart =
//       JSON.parse(localStorage.getItem("guest_cart")) ||
//       JSON.parse(localStorage.getItem("cart")) ||
//       [];
//     setCartCount(guestCart.length);
//     return;
//   }

//   // 👤 LOGGED-IN USER
//   try {
//     const res = await axios.post(
//       "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_cart",
//       { user_id }
//     );

//     if (res.data.status === true && Array.isArray(res.data.data)) {
//       setCartCount(res.data.data.length);
//     } else {
//       setCartCount(0);
//     }
//   } catch (error) {
//     console.error("Cart count error:", error);
//     setCartCount(0);
//   }
// };

// useEffect(() => {
//   const handleCartUpdate = () => fetchCartCount();

//   window.addEventListener("cartUpdated", handleCartUpdate);
//   window.addEventListener("userLoggedOut", handleCartUpdate);

//   return () => {
//     window.removeEventListener("cartUpdated", handleCartUpdate);
//     window.removeEventListener("userLoggedOut", handleCartUpdate);
//   };
// }, []);

// // const CATEGORY_MAP = {
// //   1: "Electronics",
// //   2: "Fashion",
// //   3: "Home",
// //   4: "Beauty",
// // };

// const CATEGORY_MAP = {
//   1: "Home",
//   2: "Men",
//   3: "Women",
//   4: "Kids",
//   5:"Beauty"
// };


//   const STATIC_NAV_LINKS = [
//   { label: "Story", path: "/story" },
//   { label: "About", path: "/about" },
// ];


//   useEffect(() => {
//   fetchSubCategories();
// }, []);

// const fetchSubCategories = async () => {
//   try {
//     const res = await axios.get(
//       "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
//     );

//     if (res.data.status === "true") {
//       const rows = res.data.row;

//       // Group by category_id
//       const grouped = rows.reduce((acc, item) => {
//         const catName = CATEGORY_MAP[item.category_id] || "Other";

//         if (!acc[catName]) {
//           acc[catName] = [];
//         }

//         acc[catName].push({
//           id: item.subcategory_id,
//           name: item.subcategory_name,
//           image: item.image,
//           path: `/products?subcategory=${item.subcategory_id}`,
//         });

//         return acc;
//       }, {});

//       // Convert to menu format
//       const finalMenu = Object.keys(grouped).map((key) => ({
//         label: key,
//         items: grouped[key],
//       }));

//       setMenuItems(finalMenu);
//     }
//   } catch (error) {
//     console.error("Subcategory fetch error:", error);
//   }
// };

//   return (
//     <div>
//       <div className="header sticky">
//         <div className="nav-logo">
//           <Link to="/">
//             <img src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png" alt="logo" />
//           </Link>
//         </div>

//         {/* MOBILE MENU ICON */}
//         <div
//           className="d-block d-lg-none"
//           onClick={() => setIsMobileMenuOpen((prev) => !prev)}
//         >
//           <div className="mobile-menu-icon">
//             <i className={`fas ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`}></i>
//           </div>
//         </div>

// {/* MOBILE MENU ITEMS */}
// {isMobileMenuOpen && (
//   <div className="mobile-menu m-1">
//     <ul className="mobile-menu-list">
//       {menuItems.map((menu, index) => (
//         <li key={index} className="mobile-menu-item">
//           {/* Menu Label */}
//           <div
//             className="menu-label d-flex justify-content-between align-items-center"
//             onClick={(e) => {
//               e.stopPropagation(); // 🧩 Prevent conflict with parent click
//               setOpenDropdownIndex((prev) => (prev === index ? null : index));
//             }}
//             style={{
//               cursor: "pointer",
//               fontWeight: "600",
//               padding: "10px 0",
//               borderBottom: "1px solid #e0e0e0",
//             }}
//           >
//             {menu.label}
//             <span className="mobile-arrow">
//               {openDropdownIndex === index ? "▲" : "▼"}
//             </span>
//           </div>

//           {/* Dropdown Items */}
//           {openDropdownIndex === index && (
//             <ul
//               className="submenu"
//               style={{
//                 listStyle: "none",
//                 paddingLeft: "15px",
//                 marginTop: "8px",
//                 marginBottom: "10px",
//                 backgroundColor: "#f9f9f9",
//                 borderRadius: "5px",
//                 overflow: "hidden",
//               }}
//             >
//               {menu.items.map((item, subIndex) => (
//                 <li
//                   key={subIndex}
//                   style={{
//                     padding: "8px 0",
//                     borderBottom: "1px solid #ddd",
//                   }}
//                 >
//                   <Link
//                     to={item.path}
//                     onClick={() => {
//                       setIsMobileMenuOpen(false);
//                       setOpenDropdownIndex(null);
//                     }}
//                     style={{
//                       color: "#333",
//                       textDecoration: "none",
//                       display: "block",
//                     }}
//                   >
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </li>
//       ))}
//     </ul>
//   </div>
// )}

//         <div className={`categories ${showMenu ? "show" : ""}`}>
//   <ul className="categories-ul">

//     {menuItems.map((menu, index) => (
//       <li
//         key={index}
//         className={`dropdown-content${index + 1} ${
//           activeDropdown === index ? "active" : ""
//         }`}
//       >
//         <a
//           href="#"
//           onClick={(e) => {
//             if (window.innerWidth <= 768) {
//               e.preventDefault();
//               handleAccordionToggle(index);
//             }
//           }}
//         >
//           {menu.label}

//           <span className="mobile-arrow">
//             {activeDropdown === index ? "▲" : "▼"}
//           </span>
//         </a>

//         {menu.items.length > 0 && (
//           <div className={`dropdown-menu dropdown-menu${index + 1}`}>
//             <div className="mega-menu-grid">

//               {Array.from(
//                 { length: Math.ceil(menu.items.length / 8) },
//                 (_, colIndex) => (
//                   <div className="mega-column" key={colIndex}>
//                     <h6>{menu.label}</h6>

//                     <ul>
//                       {menu.items
//                         .slice(colIndex * 8, colIndex * 8 + 8)
//                         .map((item, i) => (
//                           <li key={i}>
//                             <Link to={item.path}>
//                               {item.name}
//                             </Link>
//                           </li>
//                         ))}
//                     </ul>
//                   </div>
//                 )
//               )}

//             </div>
//           </div>
//         )}
//       </li>
//     ))}

//   </ul>
// </div>

//         <div
//           className="d-flex justify-content-center align-items-center p-3 nav-search"
//         >
//           <div
//             className="d-flex align-items-center rounded overflow-hidden"
//             style={{ width: "100%", backgroundColor: "#fff", border:"1px solid" }}
//           >
//             <div className="dropdown border-end" style={{ backgroundColor: "#f3f3f3" }}>
//               {/* <button
//                 className="btn dropdown-toggle text-muted"
//                 type="button"
//                 data-bs-toggle="dropdown"
//                 aria-expanded="false"
//                 style={{
//                   height: "38px",
//                   borderRadius: "0",
//                   backgroundColor: "#f3f3f3",
//                   border: "none",
//                   fontSize: "14px",
//                   padding: "0 10px",
//                 }}
//               >
//                 All
//               </button> */}
//               <ul className="dropdown-menu">
//                 <li>
//                   <a className="dropdown-item" href="#">
//                     All Categories
//                   </a>
//                 </li>
//                 <li>
//                   <a className="dropdown-item" href="#">
//                     Electronics
//                   </a>
//                 </li>
//                 <li>
//                   <a className="dropdown-item" href="#">
//                     Fashion
//                   </a>
//                 </li>
//               </ul>
//             </div>

//             <input
//               type="text"
//               className="form-control border-0"
//               placeholder="Search products or sellers..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && handleSearch()}
//               style={{
//                 boxShadow: "none",
//                 height: "38px",
//                 fontSize: "14px",
//               }}
//             />

//             <button
//               className="btn d-flex align-items-center justify-content-center"
//               onClick={handleSearch}
//               disabled={searchLoading}
//               style={{
//                 backgroundColor: "black",
//                 borderRadius: "0",
//                 width: "45px",
//                 height: "38px",
//               }}
//             >
//               <i className="bi bi-search fs-5 text-white"></i>
//             </button>
//           </div>
//         </div>

//         <div className="nav-last">
//           <div
//             className="profile-last-section"
//             onMouseEnter={() => setShowDropdown(true)}
//           >
//             <div
//               className="profile-icon"
//               onClick={() => setShowDropdown(!showDropdown)}
//             >
//               <img
//                 id="svg"
//                 src="https://www.svgrepo.com/show/198180/user-profile.svg"
//                 alt="profile"
//               />
//               <div>Profile</div>
//             </div>

//             {showDropdown && (
//               <div className="profile-dropdown" ref={dropdownRef}>
//                 {!isLoggedIn ? (
//                   <>
//                     <div className="welcome">
//                       <p>Welcome</p>
//                       <span>To access account and manage orders</span>
//                       <Link to="/login" onClick={() => setShowDropdown(false)}>
//                         <button>LOGIN / SIGNUP</button>
//                       </Link>
//                     </div>
//                     <hr />
//                   </>
//                 ) : (
//                   <>
//                     <div className="welcome">
//                       <p>Hello, {userName}!</p>
//                       <button 
//                         onClick={handleLogout} 
//                         style={{ 
//                           marginTop: "10px",
//                           cursor: "pointer",
//                         }}
//                       >
//                         LOGOUT
//                       </button>
//                     </div>
//                     <hr className="mt-0"/>
//                   </>
//                 )}
//                 <ul>
//                   <Link to="/Profilepage" onClick={() => setShowDropdown(false)}>
//                     <li>Profile</li>
//                   </Link>
//                   <Link to="/order" onClick={() => setShowDropdown(false)}>
//                     <li>Orders</li>
//                   </Link>
//                   <Link to="/Referfrnd" onClick={() => setShowDropdown(false)}>
//                     <li>Refer a friend</li>
//                   </Link>
//                   <li>Gift Cards</li>
//                   {/* <Link to="/ContactUs" onClick={() => setShowDropdown(false)}>
//                     <li>Contact Us</li>
//                   </Link> */}
//                   <Link to="/Coupan" onClick={() => setShowDropdown(false)}>
//                     <li>Coupons</li>
//                   </Link>
//                 </ul>
//               </div>
//             )}
//           </div>

//           <div className="profile-last-section position-relative">
//             <Link to="/wishlist" className="text-decoration-none text-dark position-relative">
//               <img
//                 id="svg"
//                 src="https://www.svgrepo.com/show/14970/heart.svg"
//                 alt=""
//               />
//               {wishcount > 0 && (
//                 <span
//                   style={{
//                     position: "absolute",
//                     top: "-5px",
//                     right: "-2px",
//                     background: "red",
//                     color: "white",
//                     borderRadius: "50%",
//                     padding: "2px 6px",
//                     fontSize: "11px",
//                     fontWeight: "bold",
//                     minWidth: "18px",
//                     textAlign: "center",
//                   }}
//                 >
//                   {wishcount}
//                 </span>
//               )}
//               <div>Wishlist</div>
//             </Link>
//           </div>

//           <div className="profile-last-section position-relative">
//             <Link to="/bag" className="text-decoration-none text-dark position-relative">
//               <FaShoppingBag size={19} />

//               {cartCount > 0 && (
//                 <span
//                   style={{
//                     position: "absolute",
//                     top: "-6px",
//                     right: "-8px",
//                     background: "red",
//                     color: "white",
//                     borderRadius: "50%",
//                     padding: "2px 6px",
//                     fontSize: "11px",
//                     fontWeight: "bold",
//                     minWidth: "18px",
//                     textAlign: "center",
//                   }}
//                 >
//                   {cartCount}
//                 </span>
//               )}

//               <div>Bag</div>
//             </Link>
//           </div>

//           <div
//             className="profile-last-section position-relative"
//             ref={notificationRef}
//           >
//             <div
//               className="text-dark text-center"
//               style={{ cursor: "pointer" }}
//               onClick={() => setShowNotifications((prev) => !prev)}
//             >
//               <i className="fa-regular fa-bell" style={{ fontSize: "18px" }}></i>
//               <div>Notifications</div>
//             </div>

//             {showNotifications && <NotificationDropdown />}
//           </div>
//         </div>
//       </div>
//       <div></div>
//     </div>
//   );
// };

// export default Navbar;  

  import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaShoppingBag } from "react-icons/fa";
import { toast } from "react-toastify";
import axios from "axios";
import NotificationDropdown from "./Notification";
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const dropdownRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [wishcount, setWishCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [sellerMap, setSellerMap] = useState({});

  const notificationRef = useRef(null);

  // 🆕 Fetch seller list and create ID-to-name mapping
  useEffect(() => {
    const fetchSellers = async () => {
      try {
        const res = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_seller_registration"
        );

        if (res.data.status === "true" && Array.isArray(res.data.data)) {
          const mapping = {};
          res.data.data.forEach((seller) => {
            mapping[seller.seller_id] = seller.business_name;
          });
          setSellerMap(mapping);
          console.log("Seller mapping created:", mapping);
        }
      } catch (error) {
        console.error("Seller fetch error:", error);
      }
    };

    fetchSellers();
  }, []);

  // Check login status
  const checkLoginStatus = () => {
    const user = localStorage.getItem("user");
    console.log("Checking login status, user data:", user);

    if (user) {
      try {
        const userData = JSON.parse(user);
        console.log("Parsed user data:", userData);
        setIsLoggedIn(true);
        setUserName(userData.name || userData.username || userData.email || userData.mobile || "User");
      } catch (error) {
        console.error("Error parsing user data:", error);
        localStorage.removeItem("user");
        setIsLoggedIn(false);
      }
    } else {
      setIsLoggedIn(false);
    }
  };

  // Check on mount and when location changes
  useEffect(() => {
    checkLoginStatus();
  }, [location]);

  // Listen for custom login event
  useEffect(() => {
    const handleLoginEvent = () => {
      console.log("Login event received");
      checkLoginStatus();
    };

    window.addEventListener("userLoggedIn", handleLoginEvent);
    return () => window.removeEventListener("userLoggedIn", handleLoginEvent);
  }, []);

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  const handleAccordionToggle = (index) => {
    if (window.innerWidth <= 768) {
      setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
    }
  };

  const handleLogout = () => {
    console.log("Logging out...");

    localStorage.removeItem("user");
    localStorage.removeItem("user_id");
    localStorage.removeItem("cart");
    localStorage.removeItem("wishlist");
    localStorage.removeItem("address");
    localStorage.removeItem("orders");

    sessionStorage.clear();

    window.dispatchEvent(new Event("userLoggedOut"));

    setIsLoggedIn(false);
    setUserName("");
    setShowDropdown(false);

    toast.success("Logged out successfully!");
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearch = async () => {
    if (!searchQuery.trim()) return;

    try {
      setSearchLoading(true);

      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
      );

      if (res.data.status === true && res.data.data) {
        const query = searchQuery.toLowerCase();

        const matchedProducts = res.data.data.filter((item) => {
          const sellerName = sellerMap[item.seller_id] || "";

          return (
            `${item.product_name} ${item.company_name} ${item.model_name} ${sellerName}`
              .toLowerCase()
              .includes(query)
          );
        });

        const transformedProducts = matchedProducts.map((product) => ({
          id: product.product_id,
          brand: product.company_name || product.assign_vendor,
          name: product.product_name,
          price: parseFloat(product.current_price),
          oldPrice: parseFloat(product.old_price),
          discount: Math.round(
            ((parseFloat(product.old_price) - parseFloat(product.current_price)) /
              parseFloat(product.old_price)) *
              100
          ),
          category: product.subcategory_id,
          category_id: Number(product.category_id),
          subcategory_id: Number(product.subcategory_id),
          color: product.available_colors,
          images:
            product.multi_image?.length > 0
              ? product.multi_image.map(
                  (img) =>
                    `https://cyberathon.com/multivendor/${img}`
                )
              : ["img/placeholder.jpg"],
          rating: parseFloat(product.rating) || 0,
          viewers: `${parseFloat(product.rating || 0).toFixed(1)}K`,
          stock: product.status || "In Stock",
          description: product.description,
          productDetails: product.product_details,
          sellerName: sellerMap[product.seller_id] || "Unknown Seller",
        }));

        console.log(`Found ${transformedProducts.length} products matching "${searchQuery}"`);

        navigate("/products", {
          state: {
            query: searchQuery,
            results: transformedProducts,
          },
        });
      }
    } catch (error) {
      console.error("Search Error:", error);
      toast.error("Search failed");
    } finally {
      setSearchLoading(false);
    }
  };

  const searchRef = useRef();

useEffect(() => {
    const handler = (e) => {
        if (
            searchRef.current &&
            !searchRef.current.contains(e.target)
        ) {
            setShowSuggestions(false);
        }
    };

    document.addEventListener("mousedown", handler);

    return () => {
        document.removeEventListener("mousedown", handler);
    };
}, []);

  const fetchProducts = async () => {
  try {
    const res = await axios.get(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
    );

    if (res.data.status === true && res.data.data) {
      setAllProducts(res.data.data);
    }
  } catch (error) {
    console.error("Product fetch error:", error);
  }
};

useEffect(() => {
  fetchProducts();
}, []);

  useEffect(() => {
    fetchwishCount();
  }, [location, isLoggedIn]);

  const fetchwishCount = async () => {
    const user_id = localStorage.getItem("user_id");

    if (!user_id) {
      const guestwish =
        JSON.parse(localStorage.getItem("guest_wishlist")) ||
        JSON.parse(localStorage.getItem("wishlist")) ||
        [];
      setWishCount(guestwish.length);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("user_id", user_id);

      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/wish_list",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      console.log("Wishlist count response:", res.data);

      if (res.data.status === true || res.data.status === "true") {
        const wishlistArray = res.data.wishlist || [];
        setWishCount(Array.isArray(wishlistArray) ? wishlistArray.length : 0);
      } else {
        setWishCount(0);
      }
    } catch (error) {
      console.error("Wishlist count error:", error);
      setWishCount(0);
    }
  };

  useEffect(() => {
    const handlewishUpdate = () => fetchwishCount();

    window.addEventListener("wishUpdated", handlewishUpdate);
    window.addEventListener("userLoggedOut", handlewishUpdate);

    return () => {
      window.removeEventListener("wishUpdated", handlewishUpdate);
      window.removeEventListener("userLoggedOut", handlewishUpdate);
    };
  }, []);

  useEffect(() => {
    fetchCartCount();
  }, [location, isLoggedIn]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(e.target)
      ) {
        setShowNotifications(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchCartCount = async () => {
    const user_id = localStorage.getItem("user_id");

    if (!user_id) {
      const guestCart =
        JSON.parse(localStorage.getItem("guest_cart")) ||
        JSON.parse(localStorage.getItem("cart")) ||
        [];
      setCartCount(guestCart.length);
      return;
    }

    try {
      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_cart",
        { user_id }
      );

      if (res.data.status === true && Array.isArray(res.data.data)) {
        setCartCount(res.data.data.length);
      } else {
        setCartCount(0);
      }
    } catch (error) {
      console.error("Cart count error:", error);
      setCartCount(0);
    }
  };

  useEffect(() => {
    const handleCartUpdate = () => fetchCartCount();

    window.addEventListener("cartUpdated", handleCartUpdate);
    window.addEventListener("userLoggedOut", handleCartUpdate);

    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
      window.removeEventListener("userLoggedOut", handleCartUpdate);
    };
  }, []);

  const CATEGORY_MAP = {
    1: "Home",
    2: "Men",
    3: "Women",
    4: "Kids",
    5: "Beauty"
  };

  const STATIC_NAV_LINKS = [
    { label: "Story", path: "/story" },
    { label: "About", path: "/about" },
  ];

  useEffect(() => {
    fetchSubCategories();
  }, []);

  const fetchSubCategories = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
      );

      if (res.data.status === "true") {
        const rows = res.data.row;

        const grouped = rows.reduce((acc, item) => {
          const catName = CATEGORY_MAP[item.category_id] || "Other";

          if (!acc[catName]) {
            acc[catName] = [];
          }

          acc[catName].push({
            id: item.subcategory_id,
            name: item.subcategory_name,
            image: item.image,
            path: `/products?subcategory=${item.subcategory_id}`,
          });

          return acc;
        }, {});

        const finalMenu = Object.keys(grouped).map((key) => ({
          label: key,
          items: grouped[key],
        }));

        setMenuItems(finalMenu);
      }
    } catch (error) {
      console.error("Subcategory fetch error:", error);
    }
  };

  return (
    <div>
      <div className="header sticky">
        <div className="nav-logo">
          <Link to="/">
            <img src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png" alt="logo" />
          </Link>
        </div>

        {/* MOBILE MENU ICON */}
        <div
          className="d-block d-lg-none"
          onClick={() => setIsMobileMenuOpen((prev) => !prev)}
        >
          <div className="mobile-menu-icon">
            <i className={`fas ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`}></i>
          </div>
        </div>

        {/* MOBILE MENU ITEMS */}
        {isMobileMenuOpen && (
          <div className="mobile-menu m-1">
            <ul className="mobile-menu-list">
              {menuItems.map((menu, index) => (
                <li key={index} className="mobile-menu-item">
                  <div
                    className="menu-label d-flex justify-content-between align-items-center"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenDropdownIndex((prev) => (prev === index ? null : index));
                    }}
                    style={{
                      cursor: "pointer",
                      fontWeight: "600",
                      padding: "10px 0",
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    {menu.label}
                    <span className="mobile-arrow">
                      {openDropdownIndex === index ? "▲" : "▼"}
                    </span>
                  </div>

                  {openDropdownIndex === index && (
                    <ul
                      className="submenu"
                      style={{
                        listStyle: "none",
                        paddingLeft: "15px",
                        marginTop: "8px",
                        marginBottom: "10px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "5px",
                        overflow: "hidden",
                      }}
                    >
                      {menu.items.map((item, subIndex) => (
                        <li
                          key={subIndex}
                          style={{
                            padding: "8px 0",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          <Link
                            to={item.path}
                            onClick={() => {
                              setIsMobileMenuOpen(false);
                              setOpenDropdownIndex(null);
                            }}
                            style={{
                              color: "#333",
                              textDecoration: "none",
                              display: "block",
                            }}
                          >
                            {item.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className={`categories ${showMenu ? "show" : ""}`}>
          <ul className="categories-ul">
            {menuItems.map((menu, index) => (
              <li
                key={index}
                className={`dropdown-content${index + 1} ${activeDropdown === index ? "active" : ""}`}
              >
                <a
                  href="#"
                  onClick={(e) => {
                    if (window.innerWidth <= 768) {
                      e.preventDefault();
                      handleAccordionToggle(index);
                    }
                  }}
                >
                  {menu.label}
                  <span className="mobile-arrow">
                    {activeDropdown === index ? "▲" : "▼"}
                  </span>
                </a>

                {menu.items.length > 0 && (
                  <div className={`dropdown-menu dropdown-menu${index + 1}`}>
                    <div className="mega-menu-grid">
                      {Array.from(
                        { length: Math.ceil(menu.items.length / 8) },
                        (_, colIndex) => (
                          <div className="mega-column" key={colIndex}>
                            <h6>{menu.label}</h6>
                            <ul>
                              {menu.items
                                .slice(colIndex * 8, colIndex * 8 + 8)
                                .map((item, i) => (
                                  <li key={i}>
                                    <Link to={item.path}>{item.name}</Link>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="d-flex justify-content-center align-items-center p-3 nav-search">
           <div
    ref={searchRef}
    style={{
      width: "100%",
      position: "relative"
    }}
  >
          <div
            className="d-flex align-items-center rounded overflow-hidden"
            style={{ width: "100%", backgroundColor: "#fff", border: "1px solid" }}
          >
            <div className="dropdown border-end" style={{ backgroundColor: "#f3f3f3" }}>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="#">All Categories</a></li>
                <li><a className="dropdown-item" href="#">Electronics</a></li>
                <li><a className="dropdown-item" href="#">Fashion</a></li>
              </ul>
            </div>

            <input
              type="text"
              className="form-control border-0"
              placeholder="Search products or sellers..."
              value={searchQuery}
              onChange={(e) => {
  const value = e.target.value;
  setSearchQuery(value);

  if (!value.trim()) {
    setSuggestions([]);
    setShowSuggestions(false);
    return;
  }

  const query = value.toLowerCase();

  const filtered = allProducts
    .filter((item) => {
      const sellerName = sellerMap[item.seller_id] || "";

      return (
        item.product_name?.toLowerCase().includes(query) ||
        item.company_name?.toLowerCase().includes(query) ||
        item.model_name?.toLowerCase().includes(query) ||
        sellerName.toLowerCase().includes(query)
      );
    })
    .slice(0, 8);

  setSuggestions(filtered);
  setShowSuggestions(true);
}}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              style={{ boxShadow: "none", height: "38px", fontSize: "14px" }}
            />

            <button
              className="btn d-flex align-items-center justify-content-center"
              onClick={handleSearch}
              disabled={searchLoading}
              style={{
                backgroundColor: "black",
                borderRadius: "0",
                width: "45px",
                height: "38px",
              }}
            >
              <i className="bi bi-search fs-5 text-white"></i>
            </button>
          </div>
          {showSuggestions && suggestions.length > 0 && (
    <div
        style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fff",
            border: "1px solid #ddd",
            zIndex: 9999,
            maxHeight: "350px",
            overflowY: "auto",
            boxShadow: "0 5px 15px rgba(0,0,0,.15)"
        }}
    >
        {suggestions.map((item) => (
            <div
                key={item.product_id}
                onClick={() => {
    setSearchQuery(item.product_name);
    setShowSuggestions(false);

    const transformedProduct = {
        id: item.product_id,
        brand: item.company_name || item.assign_vendor,
        name: item.product_name,
        price: parseFloat(item.current_price),
        oldPrice: parseFloat(item.old_price),
        discount: Math.round(
            ((parseFloat(item.old_price) - parseFloat(item.current_price)) /
                parseFloat(item.old_price)) * 100
        ),
        category: item.subcategory_id,
        category_id: Number(item.category_id),
        subcategory_id: Number(item.subcategory_id),
        color: item.available_colors,
        images:
            item.multi_image?.length > 0
                ? item.multi_image.map(
                      img => `https://cyberathon.com/multivendor/${img}`
                  )
                : ["img/placeholder.jpg"],
        rating: parseFloat(item.rating) || 0,
        viewers: `${parseFloat(item.rating || 0).toFixed(1)}K`,
        stock: item.status || "In Stock",
        description: item.description,
        productDetails: item.product_details,
        sellerName: sellerMap[item.seller_id] || "Unknown Seller",
    };

    navigate("/products", {
        state: {
            query: item.product_name,
            results: [transformedProduct], // Pass only the clicked product
        },
    });
}}
                style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee"
                }}
            >
                <img
                    src={
                        item.multi_image?.length
                            ? `https://cyberathon.com/multivendor/${item.multi_image[0]}`
                            : "/img/placeholder.jpg"
                    }
                    alt=""
                    style={{
                        width: 45,
                        height: 45,
                        objectFit: "cover",
                        marginRight: 10
                    }}
                />

                <div>
                    <div
                        style={{
                            fontWeight: 600,
                            fontSize: 14
                        }}
                    >
                        {item.product_name}
                    </div>

                    <div
                        style={{
                            fontSize: 12,
                            color: "#666"
                        }}
                    >
                        {item.company_name}
                    </div>
                </div>
            </div>
        ))}
    </div>
)}
</div>
        </div>

        <div className="nav-last">
          {/* ── Profile (always visible) ── */}
          <div
            className="profile-last-section"
            onMouseEnter={() => setShowDropdown(true)}
          >
            <div
              className="profile-icon"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <img
                id="svg"
                src="https://www.svgrepo.com/show/198180/user-profile.svg"
                alt="profile"
              />
              <div>Profile</div>
            </div>

            {showDropdown && (
              <div className="profile-dropdown" ref={dropdownRef}>
                {!isLoggedIn ? (
                  <>
                    <div className="welcome">
                      <p>Welcome</p>
                      <span>To access account and manage orders</span>
                      <Link to="/login" onClick={() => setShowDropdown(false)}>
                        <button>LOGIN / SIGNUP</button>
                      </Link>
                    </div>
                    <hr />
                  </>
                ) : (
                  <>
                    <div className="welcome">
                      <p>Hello, {userName}!</p>
                      <button
                        onClick={handleLogout}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                      >
                        LOGOUT
                      </button>
                    </div>
                    <hr className="mt-0" />
                  </>
                )}

                {/* ── Mobile-only: Wishlist / Bag / Notifications row ── */}
                <div className="mobile-dropdown-actions">
                  <Link
                    to="/wishlist"
                    onClick={() => setShowDropdown(false)}
                    className="mobile-action-item"
                  >
                    <img
                      src="https://www.svgrepo.com/show/14970/heart.svg"
                      alt="wishlist"
                      style={{ width: "18px" }}
                    />
                    <span>Wishlist</span>
                    {wishcount > 0 && (
                      <span className="mobile-badge">{wishcount}</span>
                    )}
                  </Link>

                  <Link
                    to="/bag"
                    onClick={() => setShowDropdown(false)}
                    className="mobile-action-item"
                  >
                    <FaShoppingBag size={18} />
                    <span>Bag</span>
                    {cartCount > 0 && (
                      <span className="mobile-badge">{cartCount}</span>
                    )}
                  </Link>

                  <div
                    className="mobile-action-item"
                    onClick={() => {
                      setShowDropdown(false);
                      setShowNotifications((prev) => !prev);
                    }}
                  >
                    <i className="fa-regular fa-bell" style={{ fontSize: "18px" }}></i>
                    <span>Alerts</span>
                  </div>
                </div>
                {/* ── end mobile-only row ── */}

                <hr className="mobile-actions-divider" />

                <ul>
                  <Link to="/Profilepage" onClick={() => setShowDropdown(false)}>
                    <li>Profile</li>
                  </Link>
                  <Link to="/order" onClick={() => setShowDropdown(false)}>
                    <li>Orders</li>
                  </Link>
                  <Link to="/Referfrnd" onClick={() => setShowDropdown(false)}>
                    <li>Refer a friend</li>
                  </Link>
                  <li>Gift Cards</li>
                  <Link to="/Coupan" onClick={() => setShowDropdown(false)}>
                    <li>Coupons</li>
                  </Link>
                </ul>
              </div>
            )}
          </div>

          {/* ── Wishlist (desktop only) ── */}
          <div className="profile-last-section position-relative desktop-only-icon">
            <Link to="/wishlist" className="text-decoration-none text-dark position-relative">
              <img
                id="svg"
                src="https://www.svgrepo.com/show/14970/heart.svg"
                alt=""
              />
              {wishcount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-2px",
                    background: "red",
                    color: "white",
                    borderRadius: "50%",
                    padding: "2px 6px",
                    fontSize: "11px",
                    fontWeight: "bold",
                    minWidth: "18px",
                    textAlign: "center",
                  }}
                >
                  {wishcount}
                </span>
              )}
              <div>Wishlist</div>
            </Link>
          </div>

          {/* ── Bag (desktop only) ── */}
          <div className="profile-last-section position-relative desktop-only-icon">
            <Link to="/bag" className="text-decoration-none text-dark position-relative">
              <FaShoppingBag size={19} />
              {cartCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-6px",
                    right: "-8px",
                    background: "red",
                    color: "white",
                    borderRadius: "50%",
                    padding: "2px 6px",
                    fontSize: "11px",
                    fontWeight: "bold",
                    minWidth: "18px",
                    textAlign: "center",
                  }}
                >
                  {cartCount}
                </span>
              )}
              <div>Bag</div>
            </Link>
          </div>

          {/* ── Notifications (desktop only) ── */}
          <div
            className="profile-last-section position-relative desktop-only-icon"
            ref={notificationRef}
          >
            <div
              className="text-dark text-center"
              style={{ cursor: "pointer" }}
              onClick={() => setShowNotifications((prev) => !prev)}
            >
              <i className="fa-regular fa-bell" style={{ fontSize: "18px" }}></i>
              <div>Notifications</div>
            </div>

            {showNotifications && <NotificationDropdown />}
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Navbar;